import IConnectControl from "./IConnectControl";
import { inject, injectable } from "inversify";
import SERVICE_IDENTIFIER from "../../constants/identifiers";
import SystemConfig, { CONFIG_PARAMS } from "../../system/SystemConfig";
import MadmaxError, { errorFactroy } from "../../error/MadmaxError";
import {
  ERROR_CATEGORIES,
  ERROR_CODES,
  getErrorCategoryByCode,
} from "../../error/errorCodes";
import AddFailResult from "../result/AddFailResult";
import Messages from "../../Messages";
import IErrorHandler from "../../error/IErrorHandler";
import IStatesManager from "../../states/IStatesManager";
import events from "../../events/EventsObservable";
import { GAME_EVENTS } from "../../game/gameEvents";
import { errorMessages } from "../../error/errorMessages";
import { translate } from "../../translations/translations";

export const ERROR_EVENTS = {
  // "ERROR_BALANCE_REFUND": "ERROR_BALANCE_REFUND",
  ERROR_REGULATION_COOLDOWN: "ERROR_REGULATION_COOLDOWN",
  ERROR_LOGOUT: "ERROR_LOGOUT",
};

@injectable()
export default class ConnectControl implements IConnectControl, IErrorHandler {
  protected attempts: number;
  private endRoundAttempts: number = 10;

  protected config: SystemConfig;
  private messages: Messages;
  private states: IStatesManager;

  constructor(
    @inject(SERVICE_IDENTIFIER.SystemConfig) config: SystemConfig,
    @inject(SERVICE_IDENTIFIER.SystemMessages) messages: Messages,
    @inject(SERVICE_IDENTIFIER.StatesManager) states: IStatesManager
  ) {
    this.config = config;
    this.messages = messages;
    this.states = states;

    this.attempts = 3;
  }

  reset() {
    this.attempts = 3;
    this.endRoundAttempts = 100;
  }

  async control(error, fetchType: string, data?): Promise<any> {
    let err = this.createError(error, { fetchType: fetchType });

    if (!err.isNetworkError() || --this.attempts < 1) {
      return await this.handleError(err, data); //return error
    }

    return data;
  }

  createError(error, params: any = {}): MadmaxError {
    // // increment round
    // if (error?.response?.data?.err_code === 5030) {
    //     events.dispatch(GAME_EVENTS.GAME_SKIP_ROUND_ID);
    // }

    if (!error?.response?.data?.popup_messages) {
      return errorFactroy({ error, ...params });
    } else {
      let buttons = [];
      if (
        error.response.data.popup_messages[0].buttons &&
        Array.isArray(error.response.data.popup_messages[0].buttons)
      ) {
        error.response.data.err_code = ERROR_CODES.ERROR_BUTTONS;
        const txt = error.response.data.popup_messages[0].text;
        if (!error.response.data.popup_messages[0].show_default) {
          error.response.data.message = txt;
        } else {
          let content:string;
          let title:string;
          const lang = this.config.get(CONFIG_PARAMS.LANGUAGE)
          if (errorMessages[error.response.data.code]) {
            let em = errorMessages[error.response.data.code];

            if (em.content && em.content.msg["$translate"]) {
              content = translate(em.content.msg["$translate"], lang);
            }

            if (em.content && em.content.msg["$default"]) {
              content = em.content.msg["$default"];
            }

            if (em.content && em.content.msg[lang]) {
              content = em.content.msg[lang]
            }

            if (em.title && em.title.msg[lang]) {
              title = em.title.msg[lang];
            }

            if (em.title && em.title.msg["$translate"]) {
              title = translate(em.title.msg["$translate"], lang);
            }
          }
          error.response.data.popup_messages[0].text = content
          error.response.data.popup_messages[0].title = title;
        }
        buttons = error.response.data.popup_messages[0].buttons;
      } else if (error.response.data.popup_messages[0].level === "critical") {
        error.response.data.err_code = ERROR_CODES.PLAYTECH_ERROR_CRITICAL;
      } else {
        error.response.data.err_code = ERROR_CODES.PLAYTECH_ERROR;
        error.response.data.message =
          error.response.data.popup_messages[0].text;
      }
      return errorFactroy({ error, ...params, buttons });
    }
  }

  async handleError(madmaxError, data?) {
    let errorCategory = getErrorCategoryByCode(madmaxError.code);
    switch (errorCategory) {
      case ERROR_CATEGORIES.FATAL_STOP_LOGOUT:
        this.fatalStopLogout(madmaxError);
        break;

      case ERROR_CATEGORIES.ROLLBACK:
        this.rollback(madmaxError);
        break;

      case ERROR_CATEGORIES.ROLLBACK_FATAL:
        this.rollbackFatal(madmaxError);
        break;

      case ERROR_CATEGORIES.COOLDOWN:
        this.cooldownError(madmaxError);
        break;

      case ERROR_CATEGORIES.ROUND_ENDED:
        let fetchAgain = this.roundEnded(madmaxError);
        if (fetchAgain) {
          let newData = data || {};
          newData.roundId != null && newData.roundId++;
          newData["$delayms"] = 4000;
          return Promise.resolve(newData);
        }

        return Promise.reject(madmaxError);

      default:
        this.defaultError(madmaxError);
    }

    return Promise.reject(madmaxError);
  }

  configure(_skipOnError: null | number[] | 'all'): void {}

  defaultError(error) {}

  fatalStopLogout(madmaxError) {
    this._setFailResult(madmaxError);
  }

  rollback(madmaxError) {
    this._setFailResult(madmaxError);
  }

  rollbackFatal(madmaxError) {
    this._setFailResult(madmaxError);
  }

  cooldownError(madmaxError) {
    this._setFailResult(madmaxError);
  }

  roundEnded(madmaxError): boolean {
    if (--this.endRoundAttempts <= 0) {
      return false; //this._defaultError(madmaxError);
    }

    return true;
  }

  private _setFailResult(madmaxError) {
    madmaxError.setFailResult(
      new AddFailResult(this.config.get(CONFIG_PARAMS.FAIL_RESULT))
    );
    return madmaxError;
  }
}
